import { getURL } from "../../utils";
import { Request } from "../../request";

// products
export const get_products = (
  page = 1,
  limit = 10,
  is_active = null,
  search = null,
  brand_id = null,
  category_id = null
) => {
  return Request.get(getURL(`/api/corporation-pa/products/`), {
    page,
    limit,
    is_active,
    search,
    brand_id,
    category_id,
  });
};

export const get_product = (product_id) => {
  return Request.get(getURL(`/api/corporation-pa/products/${product_id}/`));
};

export const get_brands = () => {
  return Request.get(getURL(`/api/corporation-pa/products/brands/`));
};

export const get_categories = () => {
  return Request.get(getURL(`/api/corporation-pa/products/categories/`));
};